export default __webpack_public_path__ + "static/media/oval-r.02473d8c.png";